import {
  ChangeDetectorRef,
  Directive,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  Output,
  inject,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ContextMenuService } from '../../services/context-menu.service';
import { WysiwygService } from '../../wysiwyg/services/wysiwyg.service';

@Directive({
  selector: '[appInferredHover]',
  standalone: true,
})
export class InferredHoverDirective implements OnDestroy {
  destroyed$ = new Subject<void>();
  @Input() appInferredHover: string;
  @Output() onInferredHoverChange = new EventEmitter<boolean>();
  @HostBinding('class') elementClass: string;

  private contextService = inject(ContextMenuService);
  private wysiwygService = inject(WysiwygService);
  private check = inject(ChangeDetectorRef);

  inferredHover: { [key: string]: { contextMenu?: boolean; wysiwyg?: boolean } } = {};

  private ww = this.wysiwygService.onUpdates.pipe(takeUntil(this.destroyed$)).subscribe(event => {
    if (!this.appInferredHover) return;
    if (event && event.wysiwygHoverIdentifier === this.appInferredHover) {
      this.toggleHover(event.wysiwygHoverIdentifier, 'wysiwyg', true);
    } else {
      this.toggleHoverOff('wysiwyg');
    }
  });

  private cw = this.contextService.onContextOpen.pipe(takeUntil(this.destroyed$)).subscribe(event => {
    if (!this.appInferredHover) return;

    const identifier = event?.contextHoverIdentifiers?.find(id => id === this.appInferredHover);
    if (identifier) {
      this.toggleHover(identifier, 'contextMenu', true);
    } else {
      this.toggleHoverOff('contextMenu');
    }
  });

  private toggleHover(identifier: string, type: 'contextMenu' | 'wysiwyg', value: boolean) {
    const oldVal = this.elementClass || '';
    if (!this.inferredHover[identifier]) {
      this.inferredHover[identifier] = {};
    }

    this.inferredHover[identifier][type] = value;

    const inferredHovering = Object.values(this.inferredHover[identifier]).some(Boolean);
    this.elementClass = inferredHovering ? 'inferred-hover' : '';

    if (Object.values(this.inferredHover[identifier]).every(v => !v)) {
      delete this.inferredHover[identifier];
    }

    if (oldVal !== this.elementClass) {
      this.onInferredHoverChange.emit(inferredHovering);
    }

    this.check.markForCheck();
  }

  private toggleHoverOff(type: 'contextMenu' | 'wysiwyg') {
    Object.keys(this.inferredHover).forEach(key => {
      if (this.inferredHover[key][type]) {
        this.toggleHover(key, type, false);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
